import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { hasMany, options, references } from '@apexdesigner/schema-tools';
import { horseMeasurements } from '../interface-definitions/horse-measurements';

export const match = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    mareMeasurements: horseMeasurements.describe(
      "The mare's measurements as the calculation read them.",
    ),

    stallionMeasurements: horseMeasurements.describe(
      "The stallion's measurements as the calculation read them.",
    ),

    mareSizeInfluence: z
      .number()
      .describe(
        "Weight of the mare in the foal's size, as a percentage (usually 55).",
      ),

    sirePatternInfluence: z
      .number()
      .describe(
        "Weight of the sire in the foal's pattern, as a percentage (usually 55).",
      ),

    seed: z
      .number()
      .nullable()
      .optional()
      .describe(
        'Random seed the run used. The original seeded with the time of day\nmodulo 41, so legacy runs used 0–40; unknown for loaded legacy runs.',
      ),

    calculationVersion: options([
      {
        value: 'legacy-1',
        name: 'Legacy 1',
        description:
          'Phase 1 port, exact to the original libnetmatch.so including its two quirks (+0.5 on the average, frozen size jitter)',
      },
    ]).describe(
      "Which revision of the calculation produced this match's results.",
    ),

    runTimestamp: z.coerce.date().describe('When the match was run.'),

    legacyMasterId: z
      .number()
      .nullable()
      .optional()
      .disabled()
      .describe(
        'The legacy `user_report_master.id`, for runs loaded from the old system.',
      ),

    mareId: z.number().presentAs('reference').describe('Foreign key to Horse'),

    stallionId: z
      .number()
      .presentAs('reference')
      .describe('Foreign key to Horse'),

    runById: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to User'),

    mare: references('Horse'),

    stallion: references('Horse'),

    runBy: references('User'),

    results: hasMany('MatchResult'),

    groupMatchEntries: hasMany('GroupMatchEntry'),
  })
  .describe(
    'One OptiMatch run of a mare against a stallion: the inputs, the random seed\nthat makes it reproducible, and who ran it and when. Produces a 30-month and\na 48-month match result.',
  )
  .meta({ readAs: '{mare} × {stallion}' })
  .as('Match');

export { match as matchSchema };
